import React from 'react';
import * as styles from './Icon.module.scss';

export default ({ component: IconComponent, inline, className, ...props }) => (
  <IconComponent
    className={styles.icon}
    {...props}
  />
);
